/* ============================================================
   K-home Montageanleitungen - Interaktionen (Vanilla JS)
   1) Video-Consent-Load: iframe (youtube-nocookie) erst nach Klick
   2) Anleitungs-Modal: Panels server-seitig im DOM, Fokus-Falle,
      ESC + Backdrop (Desktop), Body-Scroll-Lock
   ============================================================ */
(function () {
  'use strict';

  /* ---------- 1) Video-Consent-Load ---------- */
  function initVideos() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-kh-video]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-kh-video');
      var title = btn.getAttribute('data-kh-video-title') || '';
      if (!/^[A-Za-z0-9_-]{6,20}$/.test(id)) return;
      var frame = btn.closest('.kh-mo-video__frame');
      if (!frame) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      iframe.title = 'Video: ' + title;
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', 'allowfullscreen');
      frame.innerHTML = '';
      frame.appendChild(iframe);
    });
  }

  /* ---------- 2) Anleitungs-Modal ---------- */
  var modal, lastTrigger = null;

  function panelFor(id) {
    return document.getElementById('kh-mo-panel-' + id);
  }

  function openModal(id, trigger) {
    if (!modal) return;
    var panel = panelFor(id);
    if (!panel) return;
    lastTrigger = trigger || null;

    var panels = modal.querySelectorAll('.kh-mo-panel');
    for (var i = 0; i < panels.length; i++) panels[i].classList.remove('is-active');
    panel.classList.add('is-active');

    var typEl = modal.querySelector('[data-kh-modal-typ]');
    var titleEl = modal.querySelector('[data-kh-modal-title]');
    if (typEl) typEl.textContent = panel.getAttribute('data-typ') || '';
    if (titleEl) titleEl.textContent = (panel.getAttribute('data-name') || '') + ' montieren';
    modal.setAttribute('aria-label', 'Montageanleitung: ' + (panel.getAttribute('data-name') || ''));

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('kh-mo-lock');
    var body = modal.querySelector('.kh-mo-modal__body');
    if (body) body.scrollTop = 0;
    var closeBtn = modal.querySelector('.kh-mo-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('kh-mo-lock');
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    lastTrigger = null;
  }

  function trapFocus(e) {
    if (!modal || !modal.classList.contains('is-open') || e.key !== 'Tab') return;
    var focusables = modal.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
    var list = [];
    for (var i = 0; i < focusables.length; i++) {
      if (focusables[i].offsetParent !== null || focusables[i] === document.activeElement) list.push(focusables[i]);
    }
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function initModal() {
    modal = document.getElementById('KhMontageModal');
    if (!modal) return;

    document.addEventListener('click', function (e) {
      var card = e.target.closest('[data-kh-anleitung]');
      if (card) {
        e.preventDefault();
        openModal(card.getAttribute('data-kh-anleitung'), card);
        return;
      }
      if (e.target.closest('[data-kh-modal-close]')) {
        e.preventDefault();
        closeModal();
        return;
      }
      // Backdrop nur auf Desktop (mobil ist er ausgeblendet)
      if (e.target.classList && e.target.classList.contains('kh-mo-modal__backdrop')) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
      trapFocus(e);
    });

    // Deep-Link von Produktseiten: ?anleitung=<id> öffnet das Modal direkt
    var params = new URLSearchParams(window.location.search);
    var deep = params.get('anleitung');
    if (deep && panelFor(deep)) {
      var dl = document.getElementById('downloads');
      if (dl && dl.scrollIntoView) dl.scrollIntoView();
      openModal(deep, null);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initVideos(); initModal(); });
  } else {
    initVideos();
    initModal();
  }
})();
